export default __webpack_public_path__ + "static/foresee2-min-2989d43617d8da7bc508400ae98089a2.png";